import { render } from "./esclusioneOrariModal.vue?vue&type=template&id=be8bb14a&ts=true"
import script from "./esclusioneOrariModal.vue?vue&type=script&lang=ts"
export * from "./esclusioneOrariModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__